module.exports = __webpack_public_path__ + "assets/94588ffc0aae40b68d96b7fddff74374.svg";